document.addEventListener("DOMContentLoaded", function () {
  const ingredient = document.querySelector(".product-ingredients__wrap");
  const filterList = document.querySelector(
    ".product-ingredients__filter-list"
  );
  const ingredientItems = document.querySelectorAll(
    ".product-ingredients__info"
  );
  const ingredientWrap = document.querySelector(
    ".product-ingredients__info-wrap"
  );

  // HTML 내에 empty 메시지 추가
  const emptyMessage = document.createElement("p");
  emptyMessage.classList.add("product-ingredients__empty");
  emptyMessage.innerHTML =
    "<em>No data available. check filters</em>Sorry, we could not find any results matching your search.";
  emptyMessage.style.display = "none"; // 기본적으로 숨김
  ingredient.appendChild(emptyMessage);

  function updateIngredientItems() {
    const activeFilters = Array.from(
      document.querySelectorAll(".product-ingredients__btn--active")
    ).map((btn) => btn.getAttribute("data-filter"));

    let visibleCount = 0;

    ingredientItems.forEach((item) => {
      console.log("item", item);
      const categories = item.getAttribute("data-category").split(",");
      const shouldDisplay =
        activeFilters.length === 0 ||
        activeFilters.every((filter) => categories.includes(filter));
      item.style.display = shouldDisplay ? "" : "none";
      if (shouldDisplay) visibleCount++;
    });

    // 모든 항목이 숨겨진 경우 empty 메시지 표시
    emptyMessage.style.display = visibleCount === 0 ? "block" : "none";
  }

  if (filterList) {
    filterList.addEventListener("click", function (e) {
      const button = e.target.closest(".product-ingredients__btn");
      if (button) {
        button.classList.toggle("product-ingredients__btn--active");
        updateIngredientItems();
      }
    });
  }

  const resetButton = document.querySelector(".product-ingredients__reset");
  if (resetButton) {
    resetButton.addEventListener("click", function () {
      document.querySelectorAll(".product-ingredients__btn").forEach((item) => {
        item.classList.remove("product-ingredients__btn--active");
      });

      // 모든 항목 표시
      ingredientItems.forEach((item) => (item.style.display = ""));
      emptyMessage.style.display = "none"; // 리셋하면 empty 메시지 숨김
    });
  }
});
